Pluswerk.PlusProject.Utility.ValidateFormController = {
  errorClass: 'js-validationError error',
  successClass: 'success',
  init: function () {
    var instance = Pluswerk.PlusProject.Utility.ValidateFormController;
    $('form').each(function () {
      var $form = $(this);
      // remove 'required' if file is already uploaded:
      $form.find('.js-removeRequired').closest('.FileUpload').find('.js-validation').removeAttr('required').addClass('success');
      var $validationElements = $form.find('.js-validation');
      $validationElements.each(function () {
        var $validationElement = $(this);
        $validationElement.on('input', function () {
          if (instance.applyValidation($validationElement) === true) {
            if ($validationElement[0].files) {
              $form.find('.js-fileUpload-filename').text($validationElement[0].files[0].name);
            }
            $validationElement.addClass(Pluswerk.PlusProject.Utility.ValidateFormController.successClass).removeClass(Pluswerk.PlusProject.Utility.ValidateFormController.errorClass);
            $form.find('.js-fileUpload--wrapper').addClass(Pluswerk.PlusProject.Utility.ValidateFormController.successClass).removeClass(Pluswerk.PlusProject.Utility.ValidateFormController.errorClass);
          } else {
            $validationElement.removeClass(Pluswerk.PlusProject.Utility.ValidateFormController.successClass).addClass(Pluswerk.PlusProject.Utility.ValidateFormController.errorClass);
            $form.find('.js-fileUpload--wrapper').removeClass(Pluswerk.PlusProject.Utility.ValidateFormController.successClass).addClass(Pluswerk.PlusProject.Utility.ValidateFormController.errorClass);
          }
        });
      });

      //
      $form.find('.js-validate-maxlength').each(function () {
        instance.validateMaxLength($(this));
      });
      $form.find('.js-validate-count').each(function () {
        var $formElement = $(this)[0];
        var nodeList = $formElement.querySelectorAll('.js-multicheckbox');
        nodeList.forEach(function($input){
          $input.required = true;
          $input.onchange = function () {
            Pluswerk.PlusProject.Utility.ValidateFormController.removeRequired($formElement);
          };
        });
      });
    });
  },
  isFormSubmittable: function ($form) {
    var instance = Pluswerk.PlusProject.Utility.ValidateFormController;
    var $validationElements = $form.find('.js-validation');
    var validationSuccess = true;
    $validationElements.each(function () {
      if (validationSuccess === true) {
        validationSuccess = instance.applyValidation($(this));
      }
    });
    return validationSuccess;
  },
  applyValidation: function ($validationElement) {
    var instance = Pluswerk.PlusProject.Utility.ValidateFormController;
    var classList = $validationElement.attr('class').split(/\s+/);
    var validationSuccess = true;
    classList.forEach(function (className) {
      if (validationSuccess === true) {
        switch (className) {
          case 'js-validate-maxlength':
            validationSuccess = instance.validateMaxLength($validationElement);
            break;
          case 'js-validate-alphanumeric':
            validationSuccess = instance.validateAlphaNumeric($validationElement);
            break;
          case 'js-validate-email':
            validationSuccess = instance.validateEmail($validationElement);
            break;
          case 'js-validate-numberrange':
            validationSuccess = instance.validateNumberRange($validationElement);
            break;
          case 'js-validate-count':
            validationSuccess = instance.validateCount($validationElement);
            break;
          case 'js-validation-maxsize':
            validationSuccess = instance.validateMaxFileSize($validationElement);
            break;
          case 'js-validation-mimetype':
            validationSuccess = instance.validateMimeType($validationElement);
            break;
          default:
            break;
        }
      }
    });

    return validationSuccess;
  },
  validateMaxLength: function ($formElement) {
    var maxLength = parseInt($formElement.data('maxlength'), 10);
    if (!isNaN(maxLength) && typeof maxLength === 'number') {
      $formElement.parent().find('.js-currentLength').text($formElement.val().length);
      var input = $formElement.val();

      if (input === '') {
        return !$formElement.prop('required');
      }

      var currentLength = input.length;
      var textLengthElement = $formElement.parent();
      textLengthElement.find('.js-currentLength').text(currentLength);
      if (currentLength >= maxLength) {
        textLengthElement.addClass('textLength--max');
      } else {
        textLengthElement.removeClass('textLength--max');
      }
    }
    return true;
  },
  validateAlphaNumeric: function ($formElement) {
    var input = $formElement.val();
    if (input === '') {
      return !$formElement.prop('required');
    }

    var invalidInput = false;
    for (var i = 0; i < input.length; i++) {
      var code = input.charCodeAt(i);
      if (!(code > 47 && code < 58) && // numeric (0-9)
          !(code > 64 && code < 91) && // upper alpha (A-Z)
          !(code > 96 && code < 123) &&
          !(code === 228 || code === 246 || code === 252 || code === 196 || code === 214 || code === 220 || code === 223)) { // german äöüÄÖÜß
        invalidInput = true;
      }
    }
    return !invalidInput;
  },
  validateEmail: function ($formElement) {
    var input = $formElement.val();
    if (input === '') {
      return !$formElement.prop('required');
    }

    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(input);
  },
  validateNumberRange: function ($formElement) {
    var classList = $formElement.attr('class').split(/\s+/);
    var numberClassName = '';
    $.each(classList, function (index, className) {
      if (className.includes('js-numberrange')) {
        numberClassName = className;
      }
    });

    var numberRange = numberClassName.split('-');
    var numberRangeMin = parseInt(numberRange[2], 10);
    var numberRangeMax = parseInt(numberRange[3], 10);
    var input = $formElement.val();
    if (input === '') {
      return !$formElement.prop('required');
    }
    return !(isNaN(input) || input < numberRangeMin || input > numberRangeMax);
  },
  validateCount: function ($formElement) {
    var classList = $formElement.attr('class').split(/\s+/);
    var numberClassName = '';
    $.each(classList, function (index, className) {
      if (className.includes('js-count')) {
        numberClassName = className;
      }
    });

    var numberRange = numberClassName.split('-');
    var numberRangeMin = parseInt(numberRange[2], 10);
    var numberRangeMax = parseInt(numberRange[3], 10);
    var selectedOptions = [];
    if ($formElement.attr('data-type') === 'multiCheckbox') {
      selectedOptions = $formElement.find('input:checked');
    } else {
      var $options = $formElement.find('option');
      $options.each(function () {
        if (this.selected) {
          selectedOptions.push(this);
        }
      });
    }

    if (selectedOptions.length === 0) {
      if ($formElement.attr('data-type') === 'multiCheckbox') {
        if (!$formElement.hasClass('js-required')) {
          $formElement.removeClass(Pluswerk.PlusProject.Utility.ValidateFormController.errorClass);
          return true;
        } else {
          $formElement.addClass(Pluswerk.PlusProject.Utility.ValidateFormController.errorClass);
          return false;
        }
      }
      return !$formElement.prop('required');
    }

    return !(selectedOptions.length < numberRangeMin || selectedOptions.length > numberRangeMax);
  },
  validateMaxFileSize: function ($formElement) {
    if (!$formElement.data('maxsize')) {
      return true;
    }
    var maxFileSize = parseInt($formElement.data('maxsize'), 10);
    if ($formElement[0].files) {
      return !(maxFileSize !== 0 && $formElement[0].files[0] && $formElement[0].files[0].size > maxFileSize);
    }
    return true;
  },
  validateMimeType: function ($formElement) {
    var acceptedMimeTypesString = $formElement.attr('accept');
    if (acceptedMimeTypesString) {
      var acceptedMimeTypes = acceptedMimeTypesString.split(',');
      if ($formElement[0].files.length) {
        return acceptedMimeTypes.includes($formElement[0].files[0].type);
      }
    }
    return true;
  },
  removeRequired($formElement) {
    var nodeList = $formElement.querySelectorAll('.js-multicheckbox');
    nodeList.forEach(function($input){
      $input.required = false;
    });
  }
};
